import { useContext } from 'react';
import UIContext from '../contexts/UIContext'; // Fix: Import 'CartContext' from the correct file path

export const useUI = () => useContext(UIContext);